<template>
  <div class="sub_father">
    <div class="item_div">
      <img src="../../../static/img/服务1.png" />
      <div class="item_tv">
        <p class="title">治安防范服务</p>
        <p class="content">
          规划严密的安全防范体系，辅以先进的安监系统，高素质的安全管理队伍，确保住户生活安全舒适。
        </p>
      </div>
    </div>
    <div class="item_div">
      <img src="../../../static/img/服务2.png" />
      <div class="item_tv">
        <p class="title">设施管理服务</p>
        <p class="content">
          科学、严格的设备管理和高素质的专业技术人员，为小区提供全天候24小时公共设施保障服务。快捷的各类家庭维修服务，时刻保证住户家庭设施的运行顺畅。
        </p>
      </div>
    </div>
    <div class="item_div">
      <img src="../../../static/img/服务3.png" />
      <div class="item_tv">
        <p class="title">清洁绿化服务</p>
        <p class="content">
          专业的清洁、消杀和绿化养护队伍，精心打理、修饰每一寸空间，让业主们尽情享受洁净环境。
        </p>
      </div>
    </div>
    <div class="item_div">
      <img src="../../../static/img/服务4.png" />
      <div class="item_tv">
        <p class="title">社区文化服务</p>
        <p class="content">
          在常规物业管理服务之外，更注重社区文化的营造，为业主与业主之间搭建良好的交流平台。不定期开展社区活动，营造和谐邻里。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.sub_father {
  width: 100%;
  margin-top: 5rem;
}

.sub_father div:first-child {
  border-top: 1px dashed var(--textBlack);
  border-bottom: 1px dashed var(--textBlack);
}

.item_div {
  display: flex;
  padding: 4.8rem 2rem;
  // border-top :1px dashed var(--textBlack);
  border-bottom: 1px dashed var(--textBlack);

  img {
    width: 42.4rem;
    height: 22.5rem;
    object-fit: contain;
  }

  .item_tv {
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;
    display: flex;
    padding-left: 7.8rem;
  }

  .title {
    color: var(--textBlue);
    font-size: 2.1rem;
    text-align: left;
  }

  .content {
    text-align: left;
    font-size: 1.8rem;
    color: var(--textBlack);
  }
}

@media (max-width: 800px) {
  .item_div {
  flex-wrap:wrap;
    img{
      width:100%;
    }
    .item_tv{
      padding:0;
      margin-top:5rem;
    }
  }
}
</style>